module.exports = __webpack_public_path__ + "static/media/successStatement.be3769b9.svg";